// Module léger pour éviter les imports circulaires entre client.ts et le store notifications
let _notify: ((message: string, type: 'error' | 'success' | 'info') => void) | null = null

export function setNotifier(fn: (message: string, type: 'error' | 'success' | 'info') => void): void {
  _notify = fn
}

export function notifyError(message: string): void {
  _notify?.(message, 'error')
}

export function notifySuccess(message: string): void {
  _notify?.(message, 'success')
}
